import { observer } from "mobx-react";
import { cx } from "react-emotion";
import React from "react";
import shortid from "shortid";
import SvgIcon from "components/SvgIcon";
import radio from "./radio.svg";

function InputRadio(props) {
  const {
    id = shortid.generate(),
    label,
    name,
    style = {},
    labelWidth = "",
    inputWidth = "",
    store,
    value,
    icon,
    onChange,
    disabled,
    iconVisibleMobile = false,
    iconVisible = true,
    labelColoring = true,
    iconFirst = true,
  } = props;

  const checked = value === store.get(name);

  const iconEl = iconVisible ? (
    <label className={cx("control-label", icon, iconVisibleMobile ? "" : "hidden-xs", inputWidth)} htmlFor={id}>
      <SvgIcon src={radio} className={"icon"} />
    </label>
  ) : null;

  return (
    <div
      style={style}
      className={["radio", iconFirst && "iconFirst", checked && "selected"].filter(Boolean).join(" ")}
      data={store && store.data}
    >
      {iconFirst && iconEl}
      <label htmlFor={id} className={["control-label", labelWidth, labelColoring ? "labelColoring" : ""].join(" ")}>
        {label || name}
      </label>
      <div className={inputWidth}>
        {!iconFirst && iconEl}
        <input
          id={id}
          className="control-label hidden"
          name={name}
          onChange={!disabled && onChange}
          value={value}
          type="radio"
          checked={checked}
        />
      </div>
    </div>
  );
}

export default observer(InputRadio);
